import React, { Suspense, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'
import Header from 'src/components/Header/Header'
import Tabs from 'src/components/Tabs/Tabs'
import Loading from 'src/components/Loading/Loading'
import AssetForm from './AssetForm'
import AssetUsers from './AssetUsers/AssetUsers'
import ActivityAsset from './ActivityAsset'
import { useAsset } from 'src/hooks/api'

import './Asset.sass'
import { AssetDetails } from 'src/types'

const Asset = () => {

  const { assetId } = useParams()
  const initialAsset = useAsset(assetId)

  const [changed, setChanged] = useState(false)
  const [asset, setAsset] = useState(initialAsset)
  const [usersAccess, setUsersAccess] = useState<string[]>([])

  const handleAsset = (asset: AssetDetails) => {
    setAsset(asset)
    if (!changed) setChanged(true)
  }
  const handleUsers = (ids: string[], isInitial?: boolean) => {
    setUsersAccess(ids)
    if (!isInitial && !changed) setChanged(true)
  }
  const handleSaved = () => setChanged(false)

  const mixedAsset = { ...asset, usersAccess }

  return (
    <div id="asset" className="page">
      <Header back />
      <section id="page-content">
        <div className="container">
          <div className="only-desktop">
            <h1><FormattedMessage id="asset.title" /></h1>
            <div className="wrapper">
              <AssetForm
                asset={mixedAsset}
                setAsset={handleAsset}
                hasChanges={changed}
                onSave={handleSaved}
              />
              <Tabs
                headers={[
                  <FormattedMessage id="asset-users" />,
                  <FormattedMessage id="activity" />
                ]}
                tabs={[
                  <AssetUsers
                    slug={asset?.active.slug}
                    asset={asset}
                    value={usersAccess}
                    onChange={handleUsers}
                  />,
                  <ActivityAsset slug={asset?.active.slug} />
                ]}
              />
            </div>
          </div>
          <div className="only-mobile">
            <Tabs
              headers={[
                <FormattedMessage id="asset.title" />,
                <FormattedMessage id="asset-users" />,
                <FormattedMessage id="activity" />
              ]}
              tabs={[
                <AssetForm
                  asset={mixedAsset}
                  setAsset={handleAsset}
                  hasChanges={changed}
                  onSave={handleSaved}
                />,
                <AssetUsers
                  slug={asset?.active.slug}
                  asset={asset}
                  value={usersAccess}
                  onChange={handleUsers}
                />,
                <ActivityAsset slug={asset?.active.slug} />
              ]}
            />
          </div>
        </div>
      </section>
    </div>
  )
}

const AssetWrapper = () =>
  <Suspense fallback={<Loading />}>
    <Asset />
  </Suspense>

export default AssetWrapper
